import React, { useEffect, useRef, useState } from 'react';
import TimelineRowItem from './TimelineRowItem';

const TimelineGroupBlock = ({ group, groupIndex, totalGroups }) => {
  const groupRef = useRef(null);
  const [isGroupVisible, setIsGroupVisible] = useState(false);
  const isRight = group.align === 'right';

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsGroupVisible(true);
          if (groupRef.current) {
            observer.unobserve(groupRef.current);
          }
        }
      },
      {
        threshold: 0.15,
      }
    );

    if (groupRef.current) {
      observer.observe(groupRef.current);
    }

    return () => {
      if (groupRef.current) {
        observer.unobserve(groupRef.current);
      }
    };
  }, []);

  return (
    <div ref={groupRef} className="relative w-full mb-16 md:mb-24 last:mb-0">
      <div
        className={`hidden md:flex absolute top-0 bottom-0 w-1/2 items-center transition-opacity duration-[1000ms] ${isGroupVisible ? 'opacity-100' : 'opacity-0'
          } ${isRight ? 'left-0 justify-end pr-10 lg:pr-14' : 'right-0 justify-start pl-10 lg:pl-14'}`}
      >
        <div className="w-full max-w-[300px] lg:max-w-[360px] h-[340px] md:h-[400px] lg:h-[460px] overflow-hidden rounded-sm shadow-md">
          <img
            src={group.image}
            alt={`SeaSalt Creative Process - Step ${groupIndex + 1}`}
            className="w-full h-full object-cover object-center"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>

      <div className="flex flex-col w-full">
        {group.items.map((item, idx) => {
          const globalIndex = groupIndex * 2 + idx;
          const isFirst = globalIndex === 0;
          const isAbsoluteLast = globalIndex === totalGroups * 2 - 1;
          const isLastItemInGroup = idx === group.items.length - 1;
          return (
            <TimelineRowItem
              key={idx}
              item={item}
              isFirst={isFirst}
              isAbsoluteLast={isAbsoluteLast}
              isLastItemInGroup={isLastItemInGroup}
            />
          );
        })}

        <div
          className={`md:hidden pl-9 mt-6 transition-opacity duration-[1000ms] ${isGroupVisible ? 'opacity-100' : 'opacity-0'
            }`}
        >
          <div className="w-full max-w-[300px] h-[280px] sm:h-[340px] overflow-hidden rounded-sm shadow-md">
            <img
              src={group.image}
              alt={`SeaSalt Creative Process - Step ${groupIndex + 1}`}
              className="w-full h-full object-cover object-center"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimelineGroupBlock;
